module.exports = __webpack_public_path__ + "images/ui/ui-dropzone_0d2de79480cf290e129c9c96f51f7179.png";